import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import Seo from '../components/Seo';

const Contact = () => {
  return (
    <div className="bg-white min-h-screen">
      <Seo
        title="Contact Satis Furniture | Visit Our Campsie Outlet Store, Sydney"
        description="Get in touch with Satis Furniture in Campsie, Sydney. Call 0411 418 088, email wangjianjohn@hotmail.com, or visit 12 Perry St, Campsie NSW 2194. Open 7 days."
        path="/contact-us"
      />
      <Header />

      {/* Hero */}
      <section className="relative w-full pt-28 pb-16 md:pt-36 md:pb-20 bg-black">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 text-center">
          <h1 className="text-white text-5xl md:text-7xl lg:text-[88px] font-medium mb-4 tracking-tight font-display-serif leading-[1.05]">Get In Touch</h1>
          <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto">
            We’d love to hear from you. Reach out for enquiries, orders, or to visit our Campsie store.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 md:py-24 px-6 md:px-10 bg-white">
        <div className="max-w-[1280px] mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Info */}
          <div>
            <p className="text-xs md:text-sm text-gray-500 mb-3 tracking-[0.3em] uppercase">
              Contact Information
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-black mb-6 tracking-tight font-display-serif leading-[1.05]">
              We’re here to help
            </h2>
            <p className="text-gray-600 text-base md:text-lg mb-10 leading-relaxed">
              Visit Satis Furniture at our Campsie outlet store or reach out via phone or email. We’re open every day to help you find the perfect pieces for your home.
            </p>

            <div className="space-y-6">
              <a
                href="tel:+61411418088"
                className="flex items-start gap-4 group"
              >
                <div className="w-12 h-12 rounded-full bg-black flex items-center justify-center flex-shrink-0 group-hover:bg-gray-800 transition-colors">
                  <Phone className="w-5 h-5 text-white" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-black mb-1">Phone</h3>
                  <p className="text-sm text-gray-600 group-hover:text-black transition-colors">
                    (02) 97872567 / 0430890808 / 0411418088
                  </p>
                </div>
              </a>

              <a
                href="mailto:wangjianjohn@hotmail.com"
                className="flex items-start gap-4 group"
              >
                <div className="w-12 h-12 rounded-full bg-black flex items-center justify-center flex-shrink-0 group-hover:bg-gray-800 transition-colors">
                  <Mail className="w-5 h-5 text-white" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-black mb-1">Email</h3>
                  <p className="text-sm text-gray-600 group-hover:text-black transition-colors">
                    wangjianjohn@hotmail.com
                  </p>
                </div>
              </a>

              <a
                href="https://maps.google.com/?q=12+Perry+St+Campsie+NSW+2194"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-4 group"
              >
                <div className="w-12 h-12 rounded-full bg-black flex items-center justify-center flex-shrink-0 group-hover:bg-gray-800 transition-colors">
                  <MapPin className="w-5 h-5 text-white" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-black mb-1">Address</h3>
                  <p className="text-sm text-gray-600 group-hover:text-black transition-colors">
                    12 Perry St, Campsie NSW 2194, Australia
                  </p>
                </div>
              </a>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-black flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5 text-white" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-black mb-1">Opening Hours</h3>
                  <p className="text-sm text-gray-600">
                    Monday to Sunday · 10:30am – 5:30pm
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href="tel:+61411418088"
                className="inline-flex items-center gap-2 bg-black text-white px-7 py-3 rounded-full text-sm font-medium hover:bg-gray-800 btn-transition"
              >
                Call Now
              </a>
              <a
                href="https://maps.google.com/?q=12+Perry+St+Campsie+NSW+2194"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border-2 border-black text-black px-7 py-3 rounded-full text-sm font-medium hover:bg-black hover:text-white btn-transition"
              >
                Get Directions
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="lg:sticky lg:top-28">
            <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
              <iframe
                title="Satis Furniture Location"
                src="https://www.google.com/maps?q=12+Perry+St+Campsie+NSW+2194&output=embed"
                width="100%"
                height="520"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
